import { FETCH_RELATED } from './constants'

const initialState = {
  isFetching: false,
  items: []
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_RELATED.REQUEST: {
      return {
        ...state,
        isFetching: true,
        items: []
      }
    }
    case FETCH_RELATED.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        items: action.related
      }
    }
    case FETCH_RELATED.FAILURE: {
      return {
        ...state,
        isFetching: false,
        items: []
      }
    }
    default: {
      return state
    }
  }
}
